export class RptConfig {
  public static EndPoint = {
    Reportviewer: {
      GetProjectsFrReport: 'ProjectUser/GetUserProjects',
      GetReports: 'Powerbi/GetReports',
      GetEmbedReports: 'Powerbi/EmbedReport',
      GetEmbedDashboard: 'Powerbi/EmbedDashboard',
      GetEmbedTile: 'Powerbi/EmbedTile',
      GetProjectsdetailsFrReport : 'Powerbi/EmbedForemanReport'
    }
  };
}
